import { FeatureMockFrame } from './FeatureMockFrame';
import type { FeatureMockSize } from './FeatureMockFrame';

export const EXPRESSION_OF_INTEREST_MOCK_ALT =
  'CourtSync expressions of interest inbox for invitation-only programs with send invitation flow';

interface ExpressionOfInterestMockProps {
  size?: FeatureMockSize;
  className?: string;
}

export function ExpressionOfInterestMock({ size = 'compact', className }: ExpressionOfInterestMockProps) {
  return (
    <FeatureMockFrame
      id="expressions-of-interest"
      alt={EXPRESSION_OF_INTEREST_MOCK_ALT}
      size={size}
      className={className}
    >
      <div className="csm-eoi">
        <div className="csm-eoi-header">
          <span className="csm-eoi-title">Invitation-only program</span>
          <span className="csm-eoi-badge">Elite pathway</span>
        </div>
        <div className="csm-eoi-inbox">
          <div className="csm-eoi-row csm-eoi-row--1">
            <div className="csm-avatar">MR</div>
            <div className="csm-eoi-details">
              <span className="csm-eoi-name">Mia Roberts</span>
              <span className="csm-eoi-meta">Parent · U12</span>
            </div>
            <span className="csm-status csm-status--new">New</span>
          </div>
          <div className="csm-eoi-row csm-eoi-row--2 csm-eoi-row--selected">
            <div className="csm-avatar">TC</div>
            <div className="csm-eoi-details">
              <span className="csm-eoi-name">Tom Chen</span>
              <span className="csm-eoi-meta">Parent · U14</span>
            </div>
            <span className="csm-status csm-status--new">New</span>
          </div>
        </div>
        <div className="csm-eoi-action">
          <span className="csm-eoi-btn">Send invitation</span>
        </div>
        <div className="csm-eoi-invite-chip">Invitation link sent</div>
        <div className="csm-eoi-row csm-eoi-row--invited">
          <div className="csm-avatar">TC</div>
          <div className="csm-eoi-details">
            <span className="csm-eoi-name">Tom Chen</span>
            <span className="csm-eoi-meta">Parent · U14</span>
          </div>
          <span className="csm-status csm-status--invited">Invited</span>
        </div>
      </div>
    </FeatureMockFrame>
  );
}
